import { render } from "./PatientPreadmissionNotes.vue?vue&type=template&id=0f53dc9a&ts=true"
import script from "./PatientPreadmissionNotes.ts?vue&type=script&lang=ts&external"
export * from "./PatientPreadmissionNotes.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__